import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { PlanbookCollaborator } from "@shared/models/planbook"
import { PLANBOOK_ROLES } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    planbookId: string
    collaborator: PlanbookCollaborator
  }
}

export default class PlanbookCollaboratorSelect extends Component<Signature> {
  @service("ember-store") declare store: EmberStore
  @service declare rpc: Rpc

  availableRoles = PLANBOOK_ROLES

  @tracked isChanging = false

  @action
  updateCollaborator(collaboratorId, newRole) {
    this.isChanging = true
    this.rpc
      .planbook_collaboration_change_collaborator_role({
        planbookId: this.args.planbookId,
        collaboratorId: collaboratorId,
        role: newRole.id,
      })
      .then(() => {
        later(() => {
          if (this.isDestroyed || this.isDestroying) return
          this.isChanging = false
        }, 1000)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::PlanbookCollaboratorSelect": typeof PlanbookCollaboratorSelect
  }
}
